<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :fill="fill"
       :width="size"
       :height="size"
       viewBox="0 0 24 24">
    <path fill-rule="evenodd" d="M21.959 13.719V21.098H17.681V14.213C17.681 12.483 17.062 11.303 15.514 11.303C14.332 11.303 13.628 12.099 13.319 12.868C13.206 13.143 13.177 13.526 13.177 13.911V21.098H8.897C8.897 21.098 8.955 9.438 8.897 8.229H13.177V10.053L13.149 10.095H13.177V10.053C13.745 9.178 14.76 7.927 17.033 7.927C19.848 7.927 21.959 9.767 21.959 13.719ZM4.421 2.026C2.958 2.026 2 2.986 2 4.249C2 5.484 2.93 6.473 4.365 6.473H4.393C5.886 6.473 6.813 5.484 6.813 4.249C6.787 2.986 5.886 2.026 4.421 2.026ZM2.254 21.098H6.532V8.229H2.254V21.098Z"/>
  </svg>
</template>

<script>
export default {
  name: "LinkedinIcon",
  props: {
    fill: {
      type: String,
      default: '#F5F5F5'
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>
